import styled from 'styled-components';
import { Link } from '@material-ui/core';

export const StyledLink = styled(Link)``;
